/*
 *  Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 *  Author Rihard Tsybulka <rykhard.tsybulka@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { RootState } from '../store.typings';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { documentsClient } from '../api/documents/documentsClient';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';
import {
    DocumentDetailsAction,
    DocumentDetailsActionType,
    fetchDocumentCardDetailsSuccessAction,
    fetchDocumentCardDetailsErrorAction,
} from '../actions/documentDetailsActions';

type DocumentDetailsEpic = Epic<DocumentDetailsAction, DocumentDetailsAction, RootState>;

export const fetchDocumentCardDetailsEpic: DocumentDetailsEpic = (action$, state$) => {
    return action$.pipe(
        ofType(DocumentDetailsActionType.OPEN_REGISTRY_DOCUMENT_CARD_PAGE),
        switchMap(() => {
            const { doc } = state$.value.routerState.route.params;

            return from(documentsClient.getDocumentCard(doc)).pipe(
                map((data) => {
                    return fetchDocumentCardDetailsSuccessAction(data);
                }),

                catchError((err: AxiosError) =>
                    of(
                        fetchDocumentCardDetailsErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.failedToGetDocument')),
                        ),
                    ),
                ),
                takeUntil(action$.pipe(ofType(DocumentDetailsActionType.EXIT_REGISTRY_DOCUMENT_CARD_PAGE))),
            );
        }),
    );
};
